module.exports = "/virtual-football/img/video/clubs/france/marseille.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/france/marseille.png
// module id = 292
// module chunks = 6